import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useDemo } from "@/store/DemoStore";
import { btn, normalizePhone, isPhoneKey, normalizePhoneOnBlur } from "@/components/common";

const field = "h-11 w-full rounded-xl border border-slate-200 bg-white px-3.5 text-base text-navy-900 outline-none focus:border-navy-500 focus:ring-2 focus:ring-navy-100 sm:text-sm";
const FIELDS = [["name", "Full name", "text", true], ["email", "Email (used for MyTrip sign in)", "email", true], ["phone", "Phone", "tel"]];

export function NewClientDialog({ open, onOpenChange }) {
  const { createClient } = useDemo();
  const [f, setF] = useState({ name: "", email: "", phone: "", notes: "" });
  const nav = useNavigate();
  const set = (k) => (e) => setF({ ...f, [k]: isPhoneKey(k) ? normalizePhone(e.target.value) : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    const c = await createClient(f);
    if (c) { onOpenChange(false); nav(`/agent/clients/${c.id}`); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[calc(var(--app-h,100dvh)-2rem)] w-[calc(100vw-1.5rem)] max-w-xl overflow-y-auto rounded-2xl p-5 sm:p-7" data-testid="new-client-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-navy-900">Add Client</DialogTitle>
          <DialogDescription>Set up the client's details now. You can send their MyTrip invite from their profile when ready.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-3">
          {FIELDS.map(([k, l, type, req]) => (
            <label key={k}><span className="mb-1.5 block text-xs font-medium text-slate-500">{l}</span>
              <input required={req} type={type} className={field} value={f[k]} onChange={set(k)} onBlur={isPhoneKey(k) ? normalizePhoneOnBlur((n) => setF((p) => ({ ...p, [k]: n }))) : undefined} data-testid={`new-client-${k}`} /></label>
          ))}
          <label><span className="mb-1.5 block text-xs font-medium text-slate-500">Notes</span>
            <textarea rows={3} className={`${field} h-auto py-2.5`} value={f.notes} onChange={set("notes")} data-testid="new-client-notes" /></label>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={() => onOpenChange(false)} className={btn.secondary}>Cancel</button>
            <button className={btn.primary} data-testid="new-client-submit">Add Client</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
